import { render, staticRenderFns } from "./MiniHeader.vue?vue&type=template&id=9d1b3c96"
import script from "./MiniHeader.vue?vue&type=script&lang=js"
export * from "./MiniHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports